<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("billRecordsDetail.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("billRecordsDetail.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <!-- 账单号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.bill_code") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <a
                  :href="
                    '/#/receipts/' +
                    (bill_records && bill_records.bill
                      ? bill_records.bill.id
                      : '')
                  "
                >
                  {{ bill_records.bill ? bill_records.bill.bill_code : "" }}
                </a>
                <span>
                  ({{ $t("billRecords.Fields.created_time")
                  }}{{
                    bill_records && bill_records.bill
                      ? bill_records.bill.created
                      : "" | formatTime
                  }})
                </span>
              </v-col>
            </v-row>
            <!-- 对象 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.shop_name") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <span>
                  <v-chip
                    small
                    label
                    :color="
                      bill_records.bill
                        ? bill_records.bill.bill_obj_type
                        : '' | billObjTypeColor
                    "
                    :text-color="
                      bill_records.bill
                        ? bill_records.bill.bill_obj_type
                        : '' | billObjTypeTextColor
                    "
                  >
                    {{
                      bill_records.bill
                        ? bill_records.bill.bill_obj_type
                        : "" | billObjTypeText
                    }}
                  </v-chip>
                </span>
                <span
                  class="text-no-wrap caption font-weight-bold"
                  v-if="bill_records.bill"
                >
                  {{
                    bill_records.bill.shop
                      ? bill_records.bill.shop.shop_name
                      : bill_records.bill.supplier.supplier_name
                  }}
                </span>
                <br />
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                  v-if="bill_records.bill"
                  style="margin-left: 64px"
                >
                  {{
                    bill_records.bill.shop
                      ? bill_records.bill.shop.shop_code
                      : ""
                  }}
                </span>
              </v-col>
            </v-row>
            <!-- 类别 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.bill_type") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.bill ? bill_records.bill.bill_type_str : "" }}
              </v-col>
            </v-row>
            <!-- 单号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.detail_code") +
                  $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <a
                  v-if="bill_records.bill && bill_records.bill.bill_type == 201"
                  :href="
                    '/#/stock-orders-in/' +
                    (bill_records ? bill_records.order_id : '')
                  "
                >
                  {{ bill_records.bill ? bill_records.bill.org_code : "" }}
                </a>
                <a
                  v-else-if="
                    bill_records.bill && bill_records.bill.bill_type == 202
                  "
                  :href="
                    '/#/stock-orders-out/' +
                    (bill_records ? bill_records.order_id : '')
                  "
                >
                  {{ bill_records.bill ? bill_records.bill.org_code : "" }}
                </a>
                <a
                  v-else-if="
                    bill_records.bill && bill_records.bill.bill_type == 102
                  "
                  :href="
                    '/#/return-orders/' +
                    (bill_records ? bill_records.order_id : '')
                  "
                >
                  {{ bill_records.bill ? bill_records.bill.org_code : "" }}
                </a>
                <a
                  v-else
                  :href="
                    '/#/orders/' + (bill_records ? bill_records.order_id : '')
                  "
                >
                  {{ bill_records.bill ? bill_records.bill.org_code : "" }}
                </a>
                <span>
                  ({{ $t("billRecords.Fields.created_time")
                  }}{{
                    bill_records && bill_records.bill
                      ? bill_records.bill.order_created
                      : "" | formatTime
                  }})
                </span>
              </v-col>
            </v-row>
            <!-- 账单金额 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.bill_fee") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <span>
                  {{ $t("Global.money")
                  }}{{
                    bill_records.bill ? bill_records.bill.fee : 0 | formatMoney
                  }}
                </span>
              </v-col>
            </v-row>
            <!-- 收款 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                <span v-if="bill_records.io_type == 1">
                  {{
                    $t("billRecordsDetail.Fields.price") + $t("Global.colon")
                  }}
                </span>
                <span v-if="bill_records.io_type == 2">
                  {{ $t("billRecordsDetail.Fields.pay") + $t("Global.colon") }}
                </span>
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <span v-if="bill_records.io_type == 1">
                  <v-chip small label color="primary" dark>
                    {{ $t("Receipt.Fields.collect") }}
                  </v-chip>
                </span>
                <span v-if="bill_records.io_type == 2">
                  <v-chip small label color="danger" dark>
                    {{ $t("Receipt.Fields.pay") }}
                  </v-chip>
                </span>
                {{ $t("Global.money") }}{{ bill_records.price | formatMoney }}
              </v-col>
            </v-row>
            <!-- 手续费 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.invoice_fee") +
                  $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ $t("Global.money")
                }}{{
                  bill_records.bill
                    ? bill_records.bill.invoice_fee
                    : "" | formatMoney
                }}
              </v-col>
            </v-row>
            <!-- 日期 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("billRecordsDetail.Fields.time") + $t("Global.colon") }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.time ? bill_records.time : "" | formatDate }}
              </v-col>
            </v-row>
            <!-- 支付发起时间 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.created") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records ? bill_records.created : "" | formatTime }}
              </v-col>
            </v-row>
            <!-- 支付完成时间 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.payment_time") +
                  $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{
                  bill_records.payment_time
                    ? bill_records.payment_time
                    : bill_records.modified | formatTime
                }}
              </v-col>
            </v-row>
            <!-- 摘要 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.shop_code") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.operation_str }}
              </v-col>
            </v-row>
            <!-- 支付方式 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.pay_type") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.pay_type_str }}
              </v-col>
            </v-row>
            <!-- 凭证号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.voucher_code") +
                  $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.voucher_code }}
              </v-col>
            </v-row>
            <!-- 流水号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.bill_record_code") +
                  $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.bill_record_code }}
              </v-col>
            </v-row>
            <!-- 备注 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("billRecordsDetail.Fields.comment") + $t("Global.colon")
                }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.comment }}
              </v-col>
            </v-row>
            <!-- 自动备注 -->
            <v-row
              align="center"
              v-if="
                bill_records.bill &&
                bill_records.bill.bill_type == 101 &&
                settings &&
                settings.bill_record_auto_memo
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("billRecordsDetail.Fields.memo") + $t("Global.colon") }}
                <Required :show="savable" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                {{ bill_records.memo }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.back") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import Receipt from "@/api/bill_records";

export default {
  props: ["value", "mode"],
  components: {
    Required,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    serverErrors: [],
    bill_records: {},
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value) {
          Receipt.fetch({
            id: this.value.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.bill_records = response.data.bill_records[0];
              }
            }.bind(this)
          );
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>